module.exports = __webpack_public_path__ + "static/media/swingHandle_main.f3ceccde.png";